
import React, { useRef } from 'react';
import './CustomTabComponent.css';

const CustomTabComponent = ({ TabData, activeTabId, onClick }) => {

    const tabsRef = useRef(null);

    const handleWheel = (e) => {
        if (tabsRef.current) {
            e.preventDefault();
            tabsRef.current.scrollLeft += e.deltaY;
        }
    };

    return (
        <div style={{ padding: "8px 0", }}>
            <div
                ref={tabsRef}
                className="cust-tabs-container"
                onWheel={handleWheel}
            >
                {TabData.map((item) => (
                    item && (
                        <div
                            key={item.id}
                            className={`cust-tab ${item.id === activeTabId ? 'active' : ''}`}
                            onClick={() => onClick(item.id)}
                        >
                            {item.label}
                        </div>
                    )
                ))}
            </div>
        </div>
    );
};

export default CustomTabComponent;